import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
    
export default /*@__PURE__*/_defineComponent({
  __name: 'commonButton',
  props: {
        btnlabel: { type: String, default: "" },
        btnclass: { type: String, default: "" },
        btntype: { type: String, default: "" },
        btnicon: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
    },
  setup(__props, { expose: __expose }) {
  __expose();

    const Props = __props;

const __returned__ = { Props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})